import React from "react";
import {schemaMatches} from "@jsonforms/core";
import {withJsonFormsControlProps} from "@jsonforms/react";
import {Paper} from "@mui/material";
import {useTranslation} from "react-i18next";
import FileInputLocal, {READ_AS_DATA_URL} from "../../file-input-local";
import {RENDERER_TYPES} from "../constants";

export const ImagePickerTester = schemaMatches(schema => schema.renderer === RENDERER_TYPES.imagePicker);

export const ImagePickerRenderer = withJsonFormsControlProps(
  ({schema, label, data, handleChange, path, visible, required, errors}) => {
    const {t} = useTranslation();
    if (!visible) {
      return null;
    }
    return (
      <>
        <FileInputLocal
          fullWidth
          label={label}
          required={required}
          error={!!errors}
          helperText={errors ? t("components.customJsonForms.imagePickerRenderer.error.text") : undefined}
          variant="outlined"
          value={data || ""}
          onChange={value => handleChange(path, value ? value : undefined)}
          readAs={READ_AS_DATA_URL}
          maxFileSize={schema.options?.maxFileSize}
          accept="image/*"
          className="custom-json-forms__renderers__image-picker__field"
        />
        {data && (
          <Paper variant="outlined" className="custom-json-forms__renderers__image-picker__preview">
            <img
              src={data}
              className="custom-json-forms__renderers__image-picker__preview-image"
              style={{maxWidth: "100%", display: "block", maxHeight: "200px"}}
            />
          </Paper>
        )}
      </>
    );
  }
);
